import { render, staticRenderFns } from "./ModalCreateEducation.vue?vue&type=template&id=6c57757b&scoped=true"
import script from "./ModalCreateEducation.vue?vue&type=script&lang=js"
export * from "./ModalCreateEducation.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateEducation.vue?vue&type=style&index=0&id=6c57757b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c57757b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VSelect,VTextarea})
